module.exports = __webpack_public_path__ + "img/CCR-1.2d496b05.png";